export default __webpack_public_path__ + "static/media/slide8.0b2b382d.jpg";